import * as types from "./types";

export const refineCompetitionsListReducer = (state: types.State, action: types.Action) => {
    switch (action.type) {
        case "SET_FILTERS": {
            return { ...state, filters: action.filters };
        }
    }
};
